import { Component } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent {
  constructor(
    private translateService: TranslateService
  ) {
    this.translateService.addLangs(['fr', 'de', 'en', 'nl']);
    this.translateService.setFallbackLang('en');
    this.translateService.use('en');
  }
}
